import { safeFetch } from "./client";

export const createAbortError = () => {
  const error = new Error("Analysis request was cancelled");
  error.name = "AbortError";
  error.code = "ABORT_ERR";
  return error;
};

export const throwIfAborted = (signal) => {
  if (signal?.aborted) {
    throw createAbortError();
  }
};

export const registerRunCanceller = ({ executionControl, headers, language, runId, threadId }) => {
  if (!executionControl?.setCancelHandler || !threadId || !runId) {
    return;
  }

  executionControl.setCancelHandler(async () => {
    try {
      await safeFetch(
        `https://api.openai.com/v1/threads/${threadId}/runs/${runId}/cancel`,
        {
          method: "POST",
          headers,
        },
        language
      );
    } catch {
      return null;
    }

    return null;
  });
};
